import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const HISTORY_PAGE_SIZE = 15;

export default function HistoryPagination({ currentPage, totalItems, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(totalItems / HISTORY_PAGE_SIZE));
  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-3 py-3 text-sm dark:border-white/10">
      <span className="text-slate-500 dark:text-white/60">
        Page {currentPage} sur {totalPages}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Page précédente"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="rounded-xl border border-slate-200 p-2 text-slate-700 disabled:cursor-not-allowed disabled:opacity-35 dark:border-white/10 dark:text-white"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button
          type="button"
          aria-label="Page suivante"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="rounded-xl border border-slate-200 p-2 text-slate-700 disabled:cursor-not-allowed disabled:opacity-35 dark:border-white/10 dark:text-white"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
